import { render, staticRenderFns } from "./card-news.vue?vue&type=template&id=54292af8&scoped=true"
import script from "./card-news.vue?vue&type=script&lang=js"
export * from "./card-news.vue?vue&type=script&lang=js"
import style0 from "./card-news.vue?vue&type=style&index=0&id=54292af8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54292af8",
  null
  
)

export default component.exports